import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaSave } from 'react-icons/fa';
import api from '../../utils/api.service';
import { ENDPOINTS } from '../../utils/api-config';
import { toast } from 'react-toastify';
import './Promotions.css';

const CreatePromotion = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    discountType: 'percentage',
    discountValue: '',
    minOrderAmount: '',
    maxUsesTotal: '',
    validFrom: '',
    validUntil: '',
    maxUsesPerUser: '1'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post(ENDPOINTS.PROMOTIONS.base, {
        ...formData,
        discountValue: parseFloat(formData.discountValue),
        minOrderAmount: formData.minOrderAmount ? parseFloat(formData.minOrderAmount) : null,
        maxUsesTotal: formData.maxUsesTotal ? parseInt(formData.maxUsesTotal) : null,
        maxUsesPerUser: formData.maxUsesPerUser ? parseInt(formData.maxUsesPerUser) : 1,
      });
      toast.success('Promotion created successfully!');
      navigate('/promotions');
    } catch (error) {
      console.error('Failed to create promotion:', error);
      toast.error('Failed to create promotion: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="create-promotion-page">
      <div className="page-header">
        <button onClick={() => navigate('/promotions')} className="btn btn-secondary">
          <FaArrowLeft /> Back to Promotions
        </button>
      </div>

      <div className="content-card">
        <h3 className="card-title">Create New Promotion</h3>
        
        <form onSubmit={handleSubmit} className="promotion-form">
          <div className="form-row">
            <div className="form-group">
              <label>Promotion Code *</label>
              <input
                type="text"
                name="code"
                value={formData.code}
                onChange={handleChange}
                placeholder="e.g., SUMMER2024"
                className="form-control"
                required
              />
            </div>
            <div className="form-group">
              <label>Promotion Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g., Summer Sale"
                className="form-control"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe the promotion..."
              rows="3"
              className="form-control"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Discount Type *</label>
              <select
                name="discountType"
                value={formData.discountType}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="percentage">Percentage</option>
                <option value="fixed">Fixed Amount</option>
              </select>
            </div>
            <div className="form-group">
              <label>Discount Value *</label>
              <input
                type="number"
                name="discountValue"
                value={formData.discountValue}
                onChange={handleChange}
                placeholder={formData.discountType === 'percentage' ? 'e.g., 20' : 'e.g., 50'}
                className="form-control"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Minimum Order Amount</label>
              <input
                type="number"
                name="minOrderAmount"
                value={formData.minOrderAmount}
                onChange={handleChange}
                placeholder="e.g., 50"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Maximum Uses (Total)</label>
              <input
                type="number"
                name="maxUsesTotal"
                value={formData.maxUsesTotal}
                onChange={handleChange}
                placeholder="e.g., 1000"
                className="form-control"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Valid From *</label>
              <input
                type="date"
                name="validFrom"
                value={formData.validFrom}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
            <div className="form-group">
              <label>Valid Until *</label>
              <input
                type="date"
                name="validUntil"
                value={formData.validUntil}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Max Uses Per User</label>
            <input
              type="number"
              name="maxUsesPerUser"
              value={formData.maxUsesPerUser}
              onChange={handleChange}
              placeholder="e.g., 1"
              className="form-control"
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={() => navigate('/promotions')}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              <FaSave /> Create Promotion
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePromotion;